import { routerAsync } from '@/app-module';
import MenuFactory from '@shared/factories/menu-factory';
import { SubpropertyService } from '@modules/subproperty/subproperty-service';
import { PropertyService } from '@modules/property/property-service';
import _ from 'lodash'

export default {
  namespaced: true,

  state: {
    current: null,
    list: [],
    style: null,
    selectMap: {}
  },

  getters: {
    list: state => state.list || [],
    style: state => state.style || [],
    currentMenuItem: state => state.current || null,
    selectList: state => Object.values(state.selectMap),
    selectMap: state => state.selectMap
  },

  mutations: {
    RESETED(state) {
      state.list = [];
      state.selectMap = {};
    },
    LIST(state, payload) {
      state.list = payload;
    },
    STYLE(state, payload) {
      state.style = payload;
    },
    CURRENT(state, payload) {
      state.current = payload;
    },
    SELECT_MAP(state, payload) {
      state.selectMap = payload;
    },
  },

  actions: {
    doReset({ commit }) {
      commit('RESETED');
    },

    doInitMenu ({ commit, rootGetters, dispatch }, { manageType, doNavigation = true }) {
      if (!manageType) return;

      commit('RESETED');
      const currentUser = rootGetters['auth/currentUser'];
      const currentManage = rootGetters['auth/manage/currentManage'];
      const paymentsEnabled = rootGetters['auth/manage/paymentsEnabled'];

      let path = '/';
      if (currentManage.type === 'admin') path = '/property/list';
      if (currentManage.type === 'property') path = '/property';
      if (currentManage.type === 'subproperty') path = '/subproperty';
      
      const areRequirementsFullfiled = rootGetters[`${currentManage.type}/requirements/areRequirementsFullfiled`];
      
      const menuFactory = new MenuFactory();
      const isPropertyNBA = rootGetters['auth/manage/isPropertyNBA'];
      const menu = menuFactory.createMenu({ manageType, currentUser, areRequirementsFullfiled, isPropertyNBA, paymentsEnabled });

      commit('LIST', menu.list);
      commit('STYLE', menu.style);

      // Load options
      dispatch('doInitSelect');

      if (doNavigation) routerAsync().push(path);
    },

    async doInitSelect({ commit, rootGetters }) {
      const currentUser = rootGetters['auth/currentUser'];
      
      if (!currentUser) return
      
      const currentManage = rootGetters['auth/manage/currentManage'];
      const maxManage = rootGetters['auth/manage/maxManage'];
      const { permissions } = currentUser;

      // Property
      if (currentManage.type === 'property') {
        const { properties } = permissions;

        const isAdmin = maxManage.type === 'admin'
        var propertiesMap = {}

        if (isAdmin) {
          const { rows } = await PropertyService.list();

          for (const row of rows) {
            if (row && row.id)
            propertiesMap[row.id] = row;
          }

        } else {
          // Get from local storage
          propertiesMap = JSON.parse(localStorage.getItem('properties')) || {};

          for (const propertyId of Object.keys(properties)) {
            var property = propertiesMap[propertyId];

            if (!property) {
              property  = await PropertyService.find(propertyId);
            }

            if (property) {
              propertiesMap[propertyId] = property;
            }
          }

        }
        
        // Set to local storage
        localStorage.setItem('properties', JSON.stringify(propertiesMap));
        commit('SELECT_MAP', propertiesMap);

      // Subproperty
      } else if (currentManage.type === 'subproperty') {
        const propertyId = _.get(currentManage, 'property.id', null);
        var subpropertiesMap = {}

        if (!propertyId) return;
        const roles  = _.get(permissions, `properties.${propertyId}.roles`, []);
        const isPropertyManger = roles.some((elem) => { return elem === 'propertyManager'});
        const isAdmin = maxManage.type === 'admin'

        if (isPropertyManger || isAdmin) {
          const filter = null;
          const orderBy = null;
          const limit = null;
          const offset = null;
          const { rows } = await SubpropertyService.list(filter, orderBy, limit, offset, { type: 'property', propertyId});
          
          for (const row of rows) {
            if (row && row.id)
            subpropertiesMap[row.id] = row;
          }

        } else {
          const properties = _.get(permissions, 'properties', {});
          var subproperties  = {}
          
          for (const propertyId of  Object.keys(properties)) {
            var subProp = _.get(permissions, `properties.${propertyId}.subproperties`, {});
            Object.assign(subproperties, subProp)
          }

          // Get from local storage
          subpropertiesMap = JSON.parse(localStorage.getItem('subproperties')) || {};
          
          for (const subpropertyId of Object.keys(subproperties)) {
            var subproperty = subpropertiesMap[subpropertyId];

            if (!subproperty) {
              subproperty  = await SubpropertyService.find(subpropertyId, { type: 'subproperty'});
            }
  
            if (subproperty) {
              subpropertiesMap[subpropertyId] = subproperty;
            }
          }
        }

        // Set to local storage
        localStorage.setItem('subproperties', JSON.stringify(subpropertiesMap));
        commit('SELECT_MAP', subpropertiesMap);
      }
    },

    doChangeSelect({ getters, dispatch, rootGetters }, { select }) {
      const currentManage = rootGetters['auth/manage/currentManage'];
      let manage = {};

      if (currentManage.type === "property") {
        manage = {
          ...rootGetters['auth/manage/currentManage'],
          property: getters.selectMap[select.id],
          propertyId: getters.selectMap[select.id].id,
          model: getters.selectMap[select.id],
          type:'property',
          path: '/'
        }
      } else if (currentManage.type === "subproperty") {
        manage = {
          ...rootGetters['auth/manage/currentManage'],
          subproperty: getters.selectMap[select.id],  
          subpropertyId: getters.selectMap[select.id].id,
          model: getters.selectMap[select.id],
          type:'subproperty',
          path: '/'
        }
      }

      dispatch('auth/manage/doChangeManage', {
        manage,
        doNavigation: false,
        initMenu: false,
        forceFetch: true,
      }, {
        root: true
      });
    },

    setCurrentMenuItem({ commit }, item) {
      commit('CURRENT', item);
    }
  },
};
